import { theme } from '@Guidelines/Theme/theme';
import useWorkflowDraft from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Providers/WorkflowDraftProvider/useWorkflowDraft';
import { css } from '@emotion/react';
import type * as React from 'react';

const alertStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	padding: 1rem 1.125rem;
	border-radius: ${theme.radii.large};
	background-color: ${theme.states.danger.surface};
	color: ${theme.states.danger.solid};
`;

const titleStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	font-weight: ${theme.fontWeights.semibold};
	line-height: 1.4;
`;

const reasonStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: 0.8125rem;
	line-height: 1.55;
`;

/** Why the last save was refused; nothing is rendered while no save was refused. */
const RefusalAlert: React.FC = () => {
	const { refusalMessage } = useWorkflowDraft();

	if (refusalMessage === null) {
		return null;
	}

	return (
		<div role="alert" css={alertStyle}>
			<p css={titleStyle}>Enregistrement refusé : rien n’a été publié</p>
			<p css={reasonStyle}>{refusalMessage}</p>
		</div>
	);
};

export default RefusalAlert;
